import sendLocalRequest from "../sendLocalRequest";

export const getLastRegisteredUsers = (auth_token, count) => {
    return  new Promise( (resolve, reject) => {
        if (count === undefined) {
            reject(new Error("count is required"));
        }

        const body = {
            "count": count
        }

        let url = "users/get_last_registered_users";

        sendLocalRequest(url, "POST", auth_token, body).then( (data) => {
            resolve(data);
        }).catch( (error) => {
            reject(error);
        })
    });



};
